import { render, staticRenderFns } from "./OrderTrackingLayout.vue?vue&type=template&id=4e9e20f4&scoped=true&"
import script from "./OrderTrackingLayout.vue?vue&type=script&lang=js&"
export * from "./OrderTrackingLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrderTrackingLayout.vue?vue&type=style&index=0&id=4e9e20f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9e20f4",
  null
  
)

export default component.exports